import './registration-form.css';

import '../social-session-buttons/social-session-buttons';
import '../../util/recaptcha/recaptcha';

import './img/gauge_icon1.png';
import './img/gauge_icon1@2x.png';
